import React, {useState, useEffect, useCallback} from 'react'
import Select from 'react-select';
import  { Bar } from '@reactchartjs/react-chart.js';
import  { GraphData, GraphOptions , SetBackgroundColor, SetBorderColor } from '../../../DataPerfil'
import { ServiceDeficit, ServiceAtlethas } from '../../../infrastructure'



function random_rgba() {
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);
  return "rgb(" + r + "," + g + "," + b + ")";
}


function Index() {


  const [atlethas, setAtlehas] = useState([])
  const [atlethasForm, setAtlethasForm ] = useState([])
  const [ dataProfile , setDataProfile ] = useState( GraphData )

  const GetAtlethas = useCallback( async()=>{
    
        const data  = await ServiceAtlethas.GetAtlethas()
        let temp_data = []        
        data.map(item => temp_data.push({ label : item.name, value : item._id }))
        setAtlehas(temp_data)
  },[])

useEffect( () => {

  GetAtlethas()

},[ GetAtlethas ])



const GetDates = React.useCallback( async ( _id ) => {

      const data = await ServiceDeficit.Dates( _id )
      return data

  },[])


  const UpdateSelectedUsers = async (e) => {
    if(e === null){

      setAtlethasForm([])
      return
    }

    let temp_form = []

    await Promise.all(e.map( async item => {
      
        let result  =   await GetDates( item.value )
        let dates   =   result.map((item)=>({ label : item , value : item }))
        let date    =   ''

        atlethasForm.map((i, k) => {

          if(i._id === item.value ){
            date = i.date
          }

          return true
        })

        temp_form.push({
          label   : item.label,
          _id     : item.value,
          date,
          options : dates,
        })
  
    }))
    
      setAtlethasForm( temp_form )

  }

  const SetParams = ({ date , _id  }) => {

    const oldState = [...atlethasForm]
    atlethasForm.map((item, key) => {

      if( item._id === _id ){

        oldState[ key ].date = date
      }
      
      return true

    })


    setAtlethasForm(oldState)


  }

  useEffect(()=>{
      
    let test = []
    atlethasForm.map( item => {
        if( item.date )
          test.push({ date : item.date , athlete_id : item._id })
        return true
    })

    const GetTests = async (body)=>{

        const data = await ServiceDeficit.Stats(body)
        
        let datasets  = []
        const labels  = [
          'deficit_sj',
          'deficit_cmj',
          'deficit_continuo',

          'left_sj',
          'left_cmj',
          'left_continuo',

          'right_sj',
          'right_cmj',
          'right_continuo',
      ]
        const graph   = { ...GraphData }

        graph.labels = labels

        data.map(( item ) => {

          return datasets.push(
            {
              label: `(${item.user.name} ${item.user.identification_card})` ,
              data: [
                item.test.deficit_sj,
                item.test.deficit_cmj,
                item.test.deficit_continuo,
                
                item.test.left_sj,
                item.test.left_cmj,
                item.test.left_continuo,
                
                item.test.right_sj,
                item.test.right_cmj,
                item.test.right_continuo,
              ],
              backgroundColor:  SetBackgroundColor(random_rgba(),9),
              borderColor:      [ ...SetBorderColor( 'red' ), 1 ],
              borderWidth: 1
            }
          )
        })

        graph.datasets = datasets 

        setDataProfile( graph )


    }

    GetTests({test})


  },[ atlethasForm ])




  return (
    <div>
        <h1 style={{textAlign : 'center'}}>DEFICIT LATERAL</h1>
        
        <label>Deportistas</label>        
          <Select
              onChange={ e => UpdateSelectedUsers(e) }
              options={atlethas}
              isMulti
          />

          {atlethasForm.map(( item, key ) => {

            return (<div key={`dinamicInput_${key}`}>
              <label>{ item.label }</label>
              <br/>
              <Select
                onChange={ e => SetParams({ date : e.value, _id : item._id  }) }
                options={item.options}
              />
              <br/>
              </div>)
            })
            }



              <Bar data={ dataProfile } 
                options={ GraphOptions }
                width={100}
                height={20}
                style={{height : '20px !important'}}

                // options={{ maintainAspectRatio: false }}
              />
      </div>

  );
}

export default Index;
